<template>
	<el-drawer title="呼叫中心" v-model="drawer" size="500px">
		<el-tabs type="border-card" @tab-click="tabClick">
			<el-tab-pane label="来电">
				<el-card></el-card>
				<el-card></el-card>
				<el-card></el-card>
			</el-tab-pane>
			<el-tab-pane label="呼叫记录">
				<el-card></el-card>
				<el-card></el-card>
				<el-card></el-card>
			</el-tab-pane>
		</el-tabs>
		<!--		<el-button @click="call">call</el-button>-->
	</el-drawer>
	<audio ref="audio" autoplay></audio>
</template>
<script>
import JsSIP from 'jssip';
import {ElMessage, ElMessageBox} from "element-plus";

export default {
	components: {},
	computed: {},
	data() {
		return {
			list: [],
			drawer: false,
			ua: undefined,
			session: undefined,
			tabI: 0,
			peer: undefined
		};
	},
	created() {
		this.start();
	},
	methods: {
		start() {
			const userInfo = JSON.parse(localStorage.getItem('userInfo'));
			const configuration = {
				sockets: [new JsSIP.WebSocketInterface('ws://192.168.199.171:5066/sip-ws')],
				uri: `sip:${userInfo.id}@192.168.199.171`,
				contact_uri: `sip:${userInfo.id}@192.168.199.171:5066`,
				authorization_user: userInfo.id,
				// realm: '192.168.199.171:5066',
				password: '123456789',
				// no_answer_timeout: 10,
				register_expires: 3600
			};
			const ua = new JsSIP.UA(configuration);
			ua.start();
			ua.on('connected', (e) => {
			});
			ua.on("registered", (e) => {
			});
			ua.on("unregistered", (e) => {
			});
			ua.on("registrationExpiring", (e) => {
			});
			ua.on('disconnected', (e) => {
			});
			ua.on('newRTCSession', (data) => {
				const session = data.session;
				session.on('accepted', data => {
					const stream = new MediaStream();
					const receivers = session.connection?.getReceivers();
					if (receivers) receivers.forEach((receiver) => stream.addTrack(receiver.track));
					this.$refs.audio.srcObject = stream;
					this.$refs.audio.play();
				});
				session.on('sdp', function (data) {
					console.info('onSDP, type - ', data.type, ' sdp - ', data.sdp);
					// data.sdp = data.sdp.replace('UDP/TLS/RTP/SAVPF', 'UDP/RTP/AVPF');
					//console.info('onSDP, changed sdp - ', data.sdp);
				});
				session.on("confirmed", (data) => {
					const stream = new MediaStream();
					const receivers = session.connection?.getReceivers();
					if (receivers) {
						receivers.forEach((receiver) => stream.addTrack(receiver.track));
					}
					this.$refs.audio.srcObject = stream;
					this.$refs.audio.play();
				});
				session.on('ended', data => {
					this.$emit('phoneCall', {type: 'end'});
					this.hangUp();
				});
				session.on('failed', data => {
					this.$emit('phoneCall', {type: 'end'});
				});
				this.session = session;
				if (data.originator === 'remote') {
					this.$emit('phoneCall', {type: 'start'});
					this.answer();
				}
			});
			ua.on("newMessage", (e) => {
				const {type, sdp, iceCandidate} = JSON.parse(e.data);
				// if (type === 'answer') {
				// 	this.peer.setRemoteDescription(new RTCSessionDescription({type, sdp}));
				// } else if (type === 'answer_ice') {
				// 	this.peer.addIceCandidate(iceCandidate);
				// } else if (type === 'offer') {
				// 	this.startLive(new RTCSessionDescription({type, sdp}));
				// } else if (type === 'offer_ice') {
				// 	this.peer.addIceCandidate(iceCandidate);
				// }
			});
			ua.on("sipEvent", (e) => {
			});
			this.ua = ua;
		},
		init() {
			this.drawer = true;
		},
		call() {
			const options = {//这是配置项，具体参数可以参考官网或其他资料
				'mediaConstraints': {//设置是否允许音频或者视频
					'audio': true, 'video': false,
				},
				rtcOfferConstraints: {
					offerToReceiveAudio: true,//只接受音频流
					offerToReceiveVideo: false,//只接受视频流
				}
			};
			const call = this.ua.call(`sip:8100@192.168.199.171`, options);
		},
		async answer() {
			const stream = await navigator.mediaDevices.getUserMedia({video: false, audio: true});
			const PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
			if (!PeerConnection) ElMessageBox.alert('浏览器不支持WebRTC');
			this.peer = new PeerConnection();
			this.peer.ontrack = e => {
				if (e && e.streams) {
					this.$refs.audio.srcObject = e.streams[0];
				}
			};
			this.session.answer({
				mediaConstraints: {audio: true, video: false},
				mediaStream: stream
			});
			stream.getTracks().forEach(track => {
				this.peer.addTrack(track, stream);
			});
		},
		hangUp() {
			this.$refs.audio.pause();
			this.$refs.audio.srcObject = null;
			this.$emit('end', '');
		},
		async startLive(offerSdp) {
			let stream
			try {
				stream = await navigator.mediaDevices.getUserMedia({video: false, audio: true});
				stream.getTracks().forEach(track => {
					this.peer.addTrack(track, stream);
				});
			} catch (e) {
				console.log(e, '麦克风获取失败')
			}

			if (!offerSdp) {
				message.log('创建本地SDP');
				const offer = await this.peer.createOffer();
				await this.peer.setLocalDescription(offer);
				socket.send(JSON.stringify(offer));
			} else {
				await this.peer.setRemoteDescription(offerSdp);
				const answer = await this.peer.createAnswer();
				socket.send(JSON.stringify(answer));
				await this.peer.setLocalDescription(answer);
			}
		},
		tabClick({index}) {
			this.tabI = +index;
		},
		getList() {
		},
	},
};
</script>
